/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { Modal } from '@arco-design/web-react';
import { AIGC_PROXY_HOST } from '@/config';

type Headers = Record<string, string>;

/**
 * @brief Get
 * @param apiBasicParams
 * @param options 配置选项，包括自定义headers、baseUrl和token
 */
export const requestGetMethod = (
  apiBasicParams: string,
  options: {
    headers?: Headers;
    baseUrl?: string;
    token?: string;
  } = {}
) => {
  const { headers = {}, baseUrl = AIGC_PROXY_HOST, token } = options;

  return async (params: Record<string, any> = {}) => {
    const url = `${baseUrl}${apiBasicParams}&${Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join('&')}`;

    const requestHeaders: Headers = { ...headers };

    // 如果提供了token，添加到请求头
    if (token) {
      requestHeaders['Authorization'] = `Bearer ${token}`;
    }

    return await fetch(url, {
      headers: requestHeaders,
    });
  };
};

/**
 * @brief Post
 * @param apiBasicParams
 * @param options 配置选项，包括是否JSON格式、自定义headers、baseUrl和token
 */
export const requestPostMethod = (
  apiBasicParams: string,
  options: {
    isJson?: boolean;
    headers?: Headers;
    baseUrl?: string;
    token?: string;
  } = {}
) => {
  const { isJson = true, headers = {}, baseUrl = AIGC_PROXY_HOST, token } = options;

  return async <T>(params: T) => {
    const requestHeaders: Headers = {
      'content-type': 'application/json',
      ...headers,
    };

    // 如果提供了token，添加到请求头
    if (token) {
      requestHeaders['Authorization'] = `Bearer ${token}`;
    }

    return await fetch(`${baseUrl}${apiBasicParams}`, {
      method: 'post',
      headers: requestHeaders,
      body: (isJson ? JSON.stringify(params) : params) as BodyInit,
    });
  };
};

/**
 * @brief Handler
 * @param res
 */
export const resultHandler = (res: any) => {
  const { Result, ResponseMetadata } = res || {};
  if (Result === 'ok') {
    return Result;
  }
  const error = ResponseMetadata?.Error?.Message || Result;
  // Modal.error({
  //   title: '接口调用错误',
  //   content: `[${ResponseMetadata?.Action}]Failed(Reason: ${error}), 请参考 README 文档排查问题。`,
  // });
};
